/**
 * A credential (a digital copy of an access card) that has been loaded
 * via an access control SDK or API.
 */
export type HIDCredentialType = {
  type: string;
  metadata: any;
  label: string;
  issuer: string;
  identifier: any;
  externalId: string;
  configUrl: string;
  cardNumber: string;
  activated: boolean;
};

/**
 * Physical readers that have been found by bluetooth scanning that are
 * nearby the current user.
 */
export type HIDReaderType = {
  uuid?: string;
  name: string;
  localName?: string;
  supportedOpeningTypes: number[];
  rssi: number;
  readerType: number;
  optionalScanResponseData?: number | string;
  isInApplicationSpecificRange: boolean;
  isInMotionRange: boolean;
  isInProximityRange: boolean;
  isInSeamlessRange: boolean;
};

/**
 * Names and enums are different across the iOS and Android implementations,
 * so we standardize them here to pass thru values across the bridge.
 */
export enum HIDOpeningTypeEnum {
  Twist = 'Twist',
  Tap = 'Tap',
  Seamless = 'Seamless',
  Application = 'Application',
}

export enum HIDFeedbackEnum {
  None = 'None',
  Ring = 'Ring',
  VibrateAndRing = 'VibrateAndRing',
}

export enum HIDFeedbackTitlesEnum {
  None = 'None',
  Ring = 'Ring',
  VibrateAndRing = 'Vibrate & Ring',
}
